import { motion, useSpring, useTransform } from "framer-motion";
import { useEffect, type ReactNode } from "react";

interface CountUpProps {
  to: number;
  duration?: number;
  className?: string;
  prefix?: string;
  suffix?: string;
}

export function CountUp({
  to,
  duration = 1,
  className = "",
  prefix = "",
  suffix = "",
}: CountUpProps): ReactNode {
  const spring = useSpring(0, {
    stiffness: 60,
    damping: 20,
    duration,
  });

  const display = useTransform(spring, (current) => `${prefix}${Math.round(current)}${suffix}`);

  useEffect(() => {
    spring.set(to);
  }, [spring, to]);

  return <motion.span className={className}>{display}</motion.span>;
}
